import React from "react";
import attachFileIcon from "../../../../../../../styles/svg/attach-file.svg";
import addfile from "../../../../../../../styles/svg/add-file.svg";
import AttachFileDialog from "./AttachFileDialog";
import { CustomButton } from "../../../../../../../components/Button/Button";
import "./AttachFile.scss";
import { useCardAttachmentDialogState } from "./hooks/useCardAttachmentDialogState";

const AttachFile = ({ cardId, isIconBtn = false, isMobile = false }) => {
  const {
    canSubmit,
    file,
    handleCloseAttachFile,
    handleFileChange,
    handleNameChange,
    handleOpenAttachFile,
    handleSubmit,
    loading,
    name,
    openAttachFile,
  } = useCardAttachmentDialogState(cardId);

  return (
    <>
      {openAttachFile && (
        <AttachFileDialog
          open={openAttachFile}
          close={handleCloseAttachFile}
          canSubmit={canSubmit}
          file={file}
          handleFileChange={handleFileChange}
          handleNameChange={handleNameChange}
          handleSubmit={handleSubmit}
          loading={loading}
          name={name}
        />
      )}

      {isIconBtn ? (
        <div>
          <CustomButton
            component="label"
            className={"new-add-file reset-btn"}
            onClick={handleOpenAttachFile}
          >
            <img src={addfile} alt="" />
          </CustomButton>
        </div>
      ) : (
        <CustomButton
          variant="outlined"
          color="primary"
          className={`${isMobile
              ? "mobile-attach-btn "
              : "white-button d-flex justify-content-center align-items-center header-attach-btn attach-btn-icon"
            }`}
          component="label"
          onClick={handleOpenAttachFile}
        >
          <img
            src={attachFileIcon}
            className={`header-filter-icon ${!isMobile && "mr-2"}`}
            alt="not found"
          />
          {isMobile ? (
            ""
          ) : (
            <span className="attach-btn-content"> Add Attachment</span>
          )}
        </CustomButton>
      )}
    </>
  );
};

export default React.memo(AttachFile);
